<template>
  <div>
    <div class="px-4">
      <div class="body p-4">
        <span class="text-primary h2 d-flex align-items-center">
          <button
            @click="$router.push('/cliente/nfse/servicos')"
            class="btn font-weight-bold btn-primary text-white btn-shadow me-3"
            v-prevent-click
          >
            <i class="fa fa-arrow-left"></i>
          </button>
          <span class="text-gray"> Cadastrar Servi&ccedil;o</span>
        </span>

        <div class="card p-4 mt-4">
          <div class="p-2">
            <form @submit.prevent="submitForm">
              <div class="row text-start">

                <div class="col-lg-6 col-md-6 col-sm-12 text-primary mb-4">
                  <label for="input-name" class="form-label mb-2">
                    Nome do servi&ccedil;o*
                  </label>
                  <input
                    type="text"
                    id="input-name"
                    class="form-control"
                    placeholder="Mensalidade Sistema"
                    v-model="model.name"
                    required
                  />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 text-primary mb-4">
                  <label for="input-cnae" class="form-label mb-2">
                    CNAE
                  </label>
                  <input
                    type="text"
                    id="input-cnae"
                    class="form-control"
                    placeholder="6201-5/01"
                    v-model="model.cnae"
                  />
                </div>

                <div class="col-12 text-primary mb-4">
                  <label for="input-default-description" class="form-label mb-2">
                    Descri&ccedil;&atilde;o padr&atilde;o para NFS-e*
                  </label>
                  <textarea
                    id="input-default-description"
                    class="form-control"
                    rows="3"
                    placeholder="Mensalidade Sistema"
                    v-model="model.default_description"
                    required
                  ></textarea>
                </div>

                <div class="col-12 text-primary mb-4">
                  <nfse-classification-picker
                    v-model:classification="classification"
                    v-model:nbs="nbs"
                    v-model:ind-op="indOp"
                    v-model:class-trib="classTrib"
                  />
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                  <label for="input-default-price" class="form-label mb-2">
                    Pre&ccedil;o padr&atilde;o
                  </label>
                  <input
                    type="number"
                    id="input-default-price"
                    class="form-control"
                    placeholder="0.00"
                    step="0.01"
                    min="0"
                    v-model="model.default_price"
                  />
                </div>

              </div>

              <span class="text-center mt-4">
                <button
                  type="submit"
                  class="btn px-4 font-weight-bold btn-primary text-white btn-shadow"
                  :disabled="loaderActive"
                >
                  <span class="mx-4" v-if="!loaderActive">Cadastrar</span>
                  <span class="mx-4" v-else>Aguarde...</span>
                </button>
              </span>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import {
  getErrorMessage,
  buildNfseServicePayload,
  validateNfseServicePayload,
} from "@/utils/nfseHelpers";
import { useToast } from "vue-toastification";
import NfseClassificationPicker from "@/components/NfseClassificationPicker.vue";

const toast = useToast();

export default {
  name: "nfse-service-form",
  components: { NfseClassificationPicker },
  data() {
    return {
      loaderActive: false,
      model: {
        name: "",
        default_description: "",
        cnae: "",
        default_price: "",
      },
      classification: null,
      nbs: null,
      indOp: null,
      classTrib: null,
    };
  },
  methods: {
    async submitForm() {
      const payload = buildNfseServicePayload(this);
      const error = validateNfseServicePayload(payload);
      if (error) {
        toast.error(error);
        return;
      }

      try {
        this.loaderActive = true;
        await api.post("/company/nfse/services", payload);
        toast.success("Serviço cadastrado com sucesso.");
        this.$router.push("/cliente/nfse/servicos");
      } catch (e) {
        toast.error(
          getErrorMessage(e, "Ocorreu um erro ao salvar o serviço.")
        );
      } finally {
        this.loaderActive = false;
      }
    },
  },
};
</script>
